import { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FiHeart,
  FiShuffle,
  FiSearch
} from "react-icons/fi";
import "./ShopAll.css"

function Bestsellers(){
const navigate = useNavigate();
const sliderRef = useRef(null);
const sectionRef = useRef(null);
const [products, setProducts] = useState([]);
const [showCartPopup, setShowCartPopup] = useState(false);
const [selectedProduct, setSelectedProduct] = useState(null);
const [cartProducts, setCartProducts] = useState([]);
const [quickViewProduct, setQuickViewProduct] = useState(null);
const [showQuickView, setShowQuickView] = useState(false);
const [wishlistProducts, setWishlistProducts] = useState([]);
const [compareProducts, setCompareProducts] = useState([]);
const getUserGuestPayload = (createGuest = false) => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "null");

  const userId =
    storedUser?.id ||
    storedUser?.customer_id ||
    storedUser?.user_id ||
    "";

  let guestId = localStorage.getItem("guest_id") || "";

  if (!userId && createGuest && !guestId) {
    guestId = `guest_${Date.now()}`;
    localStorage.setItem("guest_id", guestId);
  }

  return userId
    ? { user_id: Number(userId), guest_id: "" }
    : { guest_id: guestId, user_id: "" };
};
const fetchCompare = async () => {
  try {
    const payload = getUserGuestPayload();

    if (!payload.user_id && !payload.guest_id) return;

    const res = await fetch(
      "https://aethearia.store/superadmin/api/compareList",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    console.log("Compare List:", data);

    if (data.status) {
      const ids = data.data.map((item) => Number(item.product_id));
      setCompareProducts(ids);
    } else {
      setCompareProducts([]);
    }
  } catch (err) {
    console.error("Compare fetch failed:", err);
  }
};
const handleAddToCompare = async (item) => {
  try {
    const payload = {
      ...getUserGuestPayload(true),
      product_id: Number(item.id),
    };

    const res = await fetch(
      "https://aethearia.store/superadmin/api/addToCompare",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    console.log("Compare Response:", data);

    if (data.status) {
      await fetchCompare();
    } else {
      alert(data.message || "Failed to add compare");
    }
  } catch (err) {
    console.error("Compare Error:", err);
  }
};
const fetchWishlist = async () => {
  try {
    const payload = getUserGuestPayload();

    if (!payload.user_id && !payload.guest_id) return;

    const res = await fetch(
      "https://aethearia.store/superadmin/api/wishlist-list",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    console.log("Wishlist Data:", data);

    if (data.status) {
      const ids = data.data.map((item) =>
        Number(item.product_id || item.id)
      );

      setWishlistProducts(ids);
    } else {
      setWishlistProducts([]);
    }
  } catch (err) {
    console.error("Wishlist fetch failed:", err);
  }
};
const handleAddToWishlist = async (item) => {
  if (isInWishlist(item.id)) return;

  const oldWishlist = [...wishlistProducts];
  const updatedWishlist = [...wishlistProducts, Number(item.id)];

  // instant UI update
  setWishlistProducts(updatedWishlist);

  // instant header count update
  window.dispatchEvent(
    new CustomEvent("cartWishlistUpdated", {
      detail: {
        wishlistCount: updatedWishlist.length,
      },
    })
  );

  try {
    const payload = {
      ...getUserGuestPayload(true),
      product_id: Number(item.id),
    };

    const res = await fetch(
      "https://aethearia.store/superadmin/api/add-to-wishlist",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.status) {
      await fetchWishlist();

      window.dispatchEvent(new Event("cartWishlistUpdated"));
    } else {
      setWishlistProducts(oldWishlist);

      window.dispatchEvent(
        new CustomEvent("cartWishlistUpdated", {
          detail: {
            wishlistCount: oldWishlist.length,
          },
        })
      );

      alert(data.message || "Failed to add wishlist");
    }
  } catch (err) {
    console.error("Wishlist Error:", err);

    setWishlistProducts(oldWishlist);

    window.dispatchEvent(
      new CustomEvent("cartWishlistUpdated", {
        detail: {
          wishlistCount: oldWishlist.length,
        },
      })
    );
  }
};

const isInCart = (productId) => {
  return cartProducts.some(
    (cartItem) => Number(cartItem.product_id) === Number(productId)
  );
};
const isInWishlist = (productId) => {
  return wishlistProducts.includes(Number(productId));
};
const isInCompare = (productId) => {
  return compareProducts.includes(Number(productId));
};
const fetchCart = async () => {
  try {
    const payload = getUserGuestPayload();

    if (!payload.user_id && !payload.guest_id) return;

    const res = await fetch(
      "https://aethearia.store/superadmin/api/cart-list",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.status) {
      setCartProducts(data.data || []);
    } else {
      setCartProducts([]);
    }
  } catch (err) {
    console.error(err);
  }
};
useEffect(() => {
  fetchCart();
  fetchWishlist();
  fetchCompare();
}, []);
const addToCart = async (e, item) => {
  e.preventDefault();
  e.stopPropagation();

  if (isInCart(item.id)) return;

  const oldCart = [...cartProducts];

  const updatedCart = [
    ...cartProducts,
    {
      product_id: Number(item.id),
      variant_id: Number(item.variant_id || 1),
    },
  ];

  // instant UI update
  setCartProducts(updatedCart);

  // instant header count update
  window.dispatchEvent(
    new CustomEvent("cartWishlistUpdated", {
      detail: {
        cartCount: updatedCart.length,
      },
    })
  );

  try {
    const payload = {
      ...getUserGuestPayload(true),
      product_id: Number(item.id),
      variant_id: Number(item.variant_id || 1),
      quantity: 1,
    };

    const res = await fetch(
      "https://aethearia.store/superadmin/api/add-to-cart",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.status) {
      await fetchCart();

      window.dispatchEvent(new Event("cartWishlistUpdated"));

      setSelectedProduct(item);
      setShowCartPopup(true);
    } else {
      setCartProducts(oldCart);

      window.dispatchEvent(
        new CustomEvent("cartWishlistUpdated", {
          detail: {
            cartCount: oldCart.length,
          },
        })
      );
    }
  } catch (err) {
    console.error("Add to cart failed:", err);

    setCartProducts(oldCart);

    window.dispatchEvent(
      new CustomEvent("cartWishlistUpdated", {
        detail: {
          cartCount: oldCart.length,
        },
      })
    );
  }
};
useEffect(() => {
  const fetchProducts = async () => {
    try {
      const res = await fetch(
        "https://aethearia.store/superadmin/api/featured-products"
      );

      const data = await res.json();

      if (data.status) {
        setProducts(data.data);
      }
    } catch (err) {
      console.error("Failed to fetch products:", err);
    }
  };

  fetchProducts();
}, []);
const [show, setShow] = useState(false);

useEffect(() => {

  const observer = new IntersectionObserver(
    ([entry]) => {

      if(entry.isIntersecting){
        setShow(true);
      }

    },
    {
      threshold:0.2
    }
  );

  if(sectionRef.current){
    observer.observe(sectionRef.current);
  }

  return () => {
    if(sectionRef.current){
      observer.unobserve(sectionRef.current);
    }
  };

}, []);

const scrollLeft = () => {
  if (!sliderRef.current) return;

  const card = sliderRef.current.querySelector(".product-link");
  if (!card) return;

  const cardWidth = card.offsetWidth + 20; // + gap

  sliderRef.current.scrollBy({
    left: -cardWidth,
    behavior: "smooth",
  });
};

const scrollRight = () => {
  if (!sliderRef.current) return;

  const card = sliderRef.current.querySelector(".product-link");
  if (!card) return;

  const cardWidth = card.offsetWidth + 20; // + gap

  sliderRef.current.scrollBy({
    left: cardWidth,
    behavior: "smooth",
  });
};

return(
<>
<style>{`
.bestsellers{
padding: 40px 0;
text-transform: capitalize;
overflow: hidden;
width: 80%;
margin: 0 auto;
}

.bestseller-wrap {
display: grid;
grid-template-columns: 170px 1fr;
gap: 0;
align-items: center;
}

/* LEFT PANEL */
.shop-panel{
  padding:70px 0;

  opacity:0;
  transform:translateX(-70px);

  transition:
    opacity 1s ease,
    transform 1s cubic-bezier(.22,1,.36,1);
}

.shop-panel h2{
  font-size:30px;
  margin:0 0 30px;
  font-weight:100;
    color:#4c144e;
}

.shop-btn{
  border:1px solid #4c144e;
  text-decoration:none;
  display:inline-block;
  color:#4c144e;
 background:transparent;
  transition:.35s ease;
   padding: 13px 28px !important;
}

.shop-btn:hover{
  background:#4c144e;
  color:#fff;
  border-color:#4c144e;
}

/* SLIDER */
.slider-window{
  overflow:hidden;
  position:relative;
}

.product-row{
  display:flex;
  gap:20px;
  overflow-x:auto;
  scroll-behavior:smooth;
  scrollbar-width:none;
}

.product-row::-webkit-scrollbar{
  display:none;
}

/* CARDS */
.product-card{
  background:#f1ece3;
  border-bottom:1px solid #ddd3c5;
  box-sizing:border-box;
  border-radius:0;
  opacity:0;
  transform:translateY(90px);

  transition:
    transform 1s cubic-bezier(.22,1,.36,1),
    opacity 1s ease,
    box-shadow .4s ease;
}

.product-card:hover{
   border:1px solid #4c144e !important;
     border-radius:0
}

.product-card img{
  width:100%;
  height:330px;
  display:block;
  transition:transform .8s ease;
  border:0 !important;
  object-fit:cover
}
  .product-row img{
    border:none ;
    background:transparent !important;
  }

// .product-card:hover img{
//   transform:scale(1.06);
// }

.product-info{
  padding:14px 18px 18px;
  text-align:center;
   font-Size:14px !important;
}

.product-info h4{
  text-transform:capitalize;
  margin-bottom:6px;
  color:rgb(77,67,56,1);
  font-Size:14px !important;
}
.product-info span{
  text-transform:capitalize;
  color:rgb(77,67,56,1);
  font-Size:14px !important;
}
/* NAV */
.slider-nav{
  position:absolute;
  right:10px;
  top:50%;
  transform:translateY(-50%);
  display:flex;
  flex-direction:column;
  gap:10px;
  z-index:5;
}

.nav-btn1{
  width:38px;
  height:38px;
  border:1px solid #d7ccbd;
  background:#fff;
  cursor:pointer;
  font-size:22px;
  border-radius:5px;

  display:flex;
  align-items:center;
  justify-content:center;

  transition:.3s ease;
}



/* TABLET */
@media(max-width:991px){

  .product-card{
    flex:0 0 50%;
  }

  .feature-item{
    border-right:none;
  }

}

/* MOBILE */
@media(max-width:768px){

  .bestseller-wrap{
    display:flex;
    flex-direction:column;
    gap:0;
    align-items:stretch;
  }

  .shop-panel{
    padding:0;
    text-align:left;
  }

  .shop-header{
    display:flex;
    justify-content:space-between;
    align-items:flex-start;
    gap:10px;
  }

  .shop-label{
    display:block;
    font-size:15px;
    letter-spacing:3px;
    margin-bottom:4px;
    color:#17130f;
  }

  .shop-panel h2{
    margin:0;
    font-size:26px;
  }

  .shop-btn{
    font-size:12px;
    letter-spacing:1px;
    white-space:nowrap;
    padding: 13px 22px !important;
  }

  .product-card{
    flex:0 0 80%;
    border-radius:8px;
  }

  .product-card img{
    height:250px;
  }

  .slider-nav{
    position:absolute;
    top:50%;
    left:0;
    right:0;
    transform:translateY(-50%);
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    padding:0 10px;
    pointer-events:none;
  }

  .nav-btn1{
    pointer-events:auto;
    width:36px;
    height:36px;
    background:#ffffffcc;
    border-radius:50%;
    box-shadow:0 2px 6px rgba(0,0,0,0.15);
  }

}

@media(max-width:640px){

  .product-card{
    flex:0 0 100%;
  }

}
  button {
     margin-top: 0;
         color: black;
         padding:0

}
  .shop-label{
    color:rgb(77,67,56,1);
    text-transform:uppercase;
  }
    .offer-price{
  color:#2e7d32;
  font-weight:600;
}
.product-link{
  flex:0 0 25%;
  text-decoration:none;
}

@media(max-width:991px){
  .product-link{
    flex:0 0 50%;
  }
}



.product-card{
  width:100%;
}
  .product-row{
  display:flex;
  overflow-x:auto;
  scroll-snap-type:x mandatory;
}

.product-link{
  scroll-snap-align:start;
}
  .product-row {
  scroll-snap-type: x mandatory;
}

.product-link {
  scroll-snap-align: start;
}
  .add-cart-btn{
  width:100%;
  margin-top:12px;
  padding:10px 14px;
  border:none;
border-radius: 5px;
  cursor:pointer;
  font-size:14px;
  transition:.3s ease;
  color:white
}


    @media(max-width:768px){
.bestsellers{
  padding: 0 ;
   text-transform:capitalize;
  overflow:hidden;
  width:90%;
  margin-top:50px
}
  .product-row{
    display:grid;
    grid-template-columns:repeat(2,1fr);
    gap:12px;
    overflow:visible;
    scroll-snap-type:none;
  }

  .product-link{
    flex:none;
    width:100%;
  }

  .product-card{
    width:100%;
  }

  .product-card img{
    height:250px;
    object-fit:cover
  }

  .product-info{
    padding:10px;
  }

  .product-info h4{
    font-size:14px;
    line-height:1.3;
  }

  .add-cart-btn{
    font-size:12px;
    padding:8px;
  }

  .slider-nav{
    display:none;
  }
}
  .product-image-wrap {
  position: relative;
  overflow: hidden;
}

.product-icons {
  position: absolute;
  top: 10px;
  right: 10px;

  display: flex;
  flex-direction: column;
  gap: 10px;

  opacity: 0;
  transform: translateX(10px);
  transition: 0.3s ease;
}

.product-card:hover .product-icons {
  opacity: 1;
  transform: translateX(0);
}

.product-icons button {
 width: 48px;
height: 48px;
border: 1px solid #17130f;
border-radius: 50%;
background: #17130f;
color: #f5f0e8;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
font-size: 18px;
}

.product-icons button:hover {
  background: #6c5a49;
  color: #fff;
}
  @media(max-width:768px){
  .quick-view-overlay{
    align-items: center;
    padding: 0;
  }

  .quick-view-modal{
    width: 90%;
    border-radius: 5px;
  }

  .quick-content{
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 18px;
  }

  .quick-image img{
    height: 320px;
    object-fit:cover
  }

  .quick-details h2{
    font-size: 20px;
  }

  .quick-details p,
  .quick-details h4{
    font-size: 14px;
  }

  .price{
    font-size: 20px;
    font-weight: 600;
  }

  .view-product-btn{
    width: 100%;
    padding: 12px;
    background: #17130f;
    color: #fff;
    border: none;
    border-radius: 5px;
  }
}
  .add-cart-btn:hover{
   background: #111 !important;
    color: #fff;
  }
    .add-cart-btn.added:hover{
  background:#6c5a49 !important;
}


.product-hover-img {
  position: absolute;
  inset: 0;
  opacity: 0;
  z-index: 1;
}

.product-main-img {
  opacity: 1;
  z-index: 0;
}

.product-card:hover .product-main-img {
  opacity: 0;
}

.product-card:hover .product-hover-img {
  opacity: 1;
  transform: scale(1.05);
}

.product-icons {
  z-index: 3;
}
`}</style>

<section className="bestsellers" ref={sectionRef}>

<div className="bestseller-wrap">

<div
  className="shop-panel"
  style={{
    opacity: show ? 1 : 0,
    transform: show
      ? "translateX(0)"
      : "translateX(-70px)"
  }}
>

  <div className="shop-header">

    <div>
      <span className="shop-label">our</span>
      <h2>Bestsellers</h2>
    </div>

    {/* <Link to="/shop-all" className="shop-btn" style={{ padding: '13px 27px !important;'}}>
      Shop All 
    </Link> */}

  </div>

</div>

<div className="slider-window">

<div className="product-row" ref={sliderRef}>

{products.slice(0, 8).map((item, index) => (
<Link
  key={item.id}
  to={`/product/${item.product_slug}`}
  className="product-link"
>
    <div
      className="product-card"
      style={{
        opacity: show ? 1 : 0,
        transform: show
          ? "translateY(0)"
          : "translateY(90px)",
        transitionDelay: `${0.1 + index * 0.15}s`,
      }}
    >
     
      <div className="product-image-wrap">
<img
  className="product-main-img"
  src={`https://aethearia.store/superadmin/uploads/products/Hero/${item.hero_image}`}
  alt={item.product_name}
/>

{item.variant_image && (
  <img
    className="product-hover-img"
    src={`https://aethearia.store/superadmin/uploads/products/Varient/${item.variant_image}`}
    alt={item.product_name}
  />
)}

{/* <img
  src={process.env.PUBLIC_URL + "/images/watermark.png"}
  alt="watermark"
  className="product-watermark-img"
/> */}

  {/* ICONS */}
  <div className="product-icons">
    
    {/* Wishlist (optional placeholder) */}
   <button
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();

      if (!isInWishlist(item.id)) {
        handleAddToWishlist(item);
      }
    }}
  >
    <FiHeart
      size={18}
      color={isInWishlist(item.id) ? "#e63946" : "#efe8dd"}
      fill={isInWishlist(item.id) ? "#e63946" : "transparent"}
    />
  </button>
    {/* <button
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!isInCompare(item.id)) {
      handleAddToCompare(item);
    }
  }}
  style={{
    backgroundColor: compareProducts.includes(Number(item.id))
      ? "#4c144e"
      : "#17130f",
    border: `1px solid ${
      compareProducts.includes(Number(item.id))
        ? "#d8cbb8"
        : "#17130f"
    }`,
  }}
>
  <FiShuffle
    size={18}
    color={
      compareProducts.includes(Number(item.id))
        ? "#d8cbb8"
        : "#efe8dd"
    }
  />
</button>

    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        setQuickViewProduct(item);
        setShowQuickView(true);
      }}
    >
      <FiSearch />
    </button> */}

  </div>
  
</div>

     <div className="product-info">
  <h4>{item.product_name}</h4>

  <span>
    {Number(item.min_offer_price) > 0 ? (
      <>
        <span
          style={{
            textDecoration: "line-through",
            color: "#888",
            marginRight: "8px",
          }}
        >
          ₹{item.min_price}
        </span>

        <span style={{ color: "#2e7d32" }}>
          ₹{item.min_offer_price}
        </span>
      </>
    ) : (
      <>₹{item.min_price}</>
    )}
  </span>

<button
  className={`add-cart-btn ${
    isInCart(item.id) ? "added" : ""
  }`}
  disabled={isInCart(item.id)}
  onClick={(e) => addToCart(e, item)}
>
  {isInCart(item.id)
    ? "Added To Cart"
    : "+ Add To Cart"}
</button>
</div>
    </div>
  </Link>
))}

</div>

<div className="slider-nav">
<button className="nav-btn1" onClick={scrollLeft}>‹</button>
<button className="nav-btn1" onClick={scrollRight}>›</button>
</div>

</div>

</div>

</section>
{showCartPopup && selectedProduct && (
  <div className="cart-popup-overlay">
    <div className="cart-popup">

      <button
        className="popup-close"
        onClick={() => setShowCartPopup(false)}
      >
        ✕
      </button>

      <div className="popup-top">
        <span>✓</span>
        <p>Item added to your cart</p>
      </div>

      <div className="popup-product">

        <img
          src={`https://aethearia.store/superadmin/uploads/products/Hero/${selectedProduct.hero_image}`}
          alt=""
        />

        <div>
          <h4>{selectedProduct.product_name}</h4>

          <span>
            ₹
            {selectedProduct.min_offer_price > 0
              ? selectedProduct.min_offer_price
              : selectedProduct.min_price}
          </span>
        </div>

      </div>

      <button
        className="view-cart-btn"
        onClick={() => navigate("/cart")}
      >
        View Cart
      </button>

      <button
        className="checkout-btn"
        onClick={() => navigate("/checkout")}
      >
        Checkout
      </button>

      <button
        className="continue-btn"
        onClick={() => setShowCartPopup(false)}
      >
        Continue Shopping
      </button>

    </div>
  </div>
)}
{showQuickView && quickViewProduct && (
  <div
    className="quick-view-overlay"
    onClick={() => setShowQuickView(false)}
  >
    <div
      className="quick-view-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="quick-close"
        onClick={() => setShowQuickView(false)}
      >
        ✕
      </button>

      <div className="quick-content">

        <div className="quick-image">
         <img
        src={`https://aethearia.store/superadmin/uploads/products/Hero/${quickViewProduct.hero_image}`}
        alt=""
      />
        </div>

        <div className="quick-details">

          <h2>{quickViewProduct.name}</h2>
            <h4 className="description">
            {quickViewProduct.catname}
          </h4>
          <p className="sku">
            SKU ID: {quickViewProduct.sku}
          </p>

          <p className="description">
            {quickViewProduct.short_description}
          </p>

         <div className="price">
          ₹
          {Number(quickViewProduct.min_offer_price) > 0
            ? quickViewProduct.min_offer_price
            : quickViewProduct.min_price}
        </div>

          <button
            className="view-product-btn"
            onClick={() =>
              navigate(`/product/${quickViewProduct.product_slug}`)
            }
          >
            VIEW PRODUCT
          </button>

        </div>

      </div>
    </div>
  </div>
)}
</>
)
}

export default Bestsellers;